import { Badge } from "@/components/ui/badge";

const MAP = {
  Yes: "bg-primary text-primary-foreground",
  No: "bg-muted text-muted-foreground border border-border",
  Active: "bg-primary text-primary-foreground",
  Closed: "bg-muted text-muted-foreground border border-border",
  Refunded: "bg-muted text-muted-foreground border border-border",
  Disputed: "bg-destructive text-destructive-foreground",
  completed: "bg-primary text-primary-foreground",
  sent: "bg-[hsl(30_60%_45%)] text-white",
  viewed: "bg-[hsl(43_55%_45%)] text-white",
  pending_setup: "bg-muted text-muted-foreground border border-border",
  not_applicable: "bg-secondary text-secondary-foreground border border-border",
  error: "bg-destructive text-destructive-foreground",
};

const LABELS = {
  pending_setup: "Pending DocuSign",
  not_applicable: "N/A",
  sent: "Sent",
  viewed: "Viewed",
  completed: "Signed",
  error: "Send Failed",
};

export function StatusBadge({ value, testid }) {
  if (!value) return <span className="text-muted-foreground text-xs">—</span>;
  return (
    <Badge
      data-testid={testid}
      className={`rounded-none font-mono text-[11px] uppercase tracking-wide px-2 py-0.5 ${MAP[value] || "bg-secondary"}`}
    >
      {LABELS[value] || value}
    </Badge>
  );
}
